module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/project-design-issue-total/project-design-issue-all-form/project-design-issue-all-form.component.css
// module id = ./src/app/technical/project-design-issue-total/project-design-issue-all-form/project-design-issue-all-form.component.css
// module chunks = main